import React, {memo} from "react";
import PropTypes from "prop-types";
import {Box, IconButton} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {StyledTooltip} from "../../components";
import {chatbotMessageToPlainText} from "./chatbotHelpers";
import {ALERT} from "../../resources/environment";
import {useChatbotMessageStyles} from "./useChatbotMessageStyles";

const ChatbotMessageToolbar = ({message, hide}) => {
  const {classes} = useChatbotMessageStyles();
  if (hide) {
    return null;
  }

  const handleCopy = () => {
    navigator?.clipboard?.writeText(chatbotMessageToPlainText(message));
    ALERT.success("Copied to clipboard");
  };

  return (
    <Box id="message-toolbar" className={classes.messageToolbar}>
      <StyledTooltip title="Copy response" placement="top">
        <IconButton
          id="copy-message"
          size="small"
          onClick={handleCopy}
          className={classes.messageToolbarCopyButton}
          disableRipple
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </StyledTooltip>
    </Box>
  );
};

ChatbotMessageToolbar.propTypes = {
  message: PropTypes.object.isRequired,
  hide: PropTypes.bool,
};

export default memo(ChatbotMessageToolbar);
